import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: 'AIzaSyC99PHOC8Cb2jt6uvPHVc-Sz55lYkP3nNE',
  authDomain: 'kunde-database---lykkeel.firebaseapp.com',
  projectId: 'kunde-database---lykkeel',
  storageBucket: 'kunde-database---lykkeel.firebasestorage.app',
  messagingSenderId: '670410223128',
  appId: '1:670410223128:web:862a41260b2f8dbd09dd6d',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firestore
export const db = getFirestore(app)

// Initialize Storage
export const storage = getStorage(app)
